import Box from "@mui/material/Box";
import React from 'react';
import { searchStyleAutocompleteOption } from '../SearchBar.style';
export const CustomOption = (props) => {
    return (React.createElement(Box, Object.assign({ component: "li" }, props, { sx: searchStyleAutocompleteOption }), props.children));
};
